//--- React
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Row } from "antd";
//--- Project
import { TEST_RIDE_SUMMARY } from "components/Common/Grafana/Constants";
import { UNITS } from "components/Common/Constants";
import panelList from "../panelList.json";
import ChartFilter from "components/Common/ChartFilter";
import PanelsRow from "components/Common/Grafana/PanelsRow";

const BrakeAnalytics = ({ baseUrl, baseFilterObject }) => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [chartType, setChartType] = useState({
    timeSeries: true,
    histogram: false,
    boxPlot: false,
  });
  const [brakeList, setBrakeList] = useState([]);

  useEffect(() => {
    setBrakeList(panelList?.brake);
  }, []);

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  const subContent = (
    <>
      <Row gutter={[16, 16]} justify="end" className="mt105">
        <Col xs={8} sm={6} md={4} lg={3} xl={3}>
          <ChartFilter
            updateChartType={updateChartType}
            chartType={chartType}
          />
        </Col>
      </Row>
      <div className="grey-box mt105">
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={24} md={24} lg={6} xl={6} className="flex-center">
            Total Brakes:
            <span className="ml025 bold">{tripSummary?.totalBrakes}</span>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} className="flex-center">
            Brakes/km:
            <span className="ml025 bold">{tripSummary?.brakesPerKm}</span>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} className="flex-center">
            Avg Distance/Brake:
            <span className="ml025 bold">
              {tripSummary?.averageDistancePerBrake}
            </span>
            <span className="ml025">{UNITS.METER}</span>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} className="flex-center">
            Avg Duration/Brake:
            <span className="ml025 bold">
              {tripSummary?.averageDurationPerBrake}
            </span>
            <span className="ml025">{UNITS.SECONDS}</span>
          </Col>
        </Row>
      </div>
    </>
  );

  return (
    <>
      {subContent}
      <Row className="pd0">
        {brakeList?.map((panel, index) => (
          <Col key={index} span={24}>
            <PanelsRow
              title={panel.title}
              url={baseUrl}
              timeSeriesPanel={
                chartType?.timeSeries &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["timeSeries"]
              }
              histogramPanel={
                chartType?.histogram &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["histogram"]
              }
              boxPlotPanel={
                chartType?.boxPlot &&
                TEST_RIDE_SUMMARY.PANEL_ID[panel.var_name]["boxPlot"]
              }
              baseFilterObject={baseFilterObject}
              variableKeys={TEST_RIDE_SUMMARY.BASE_VARIABLES}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default BrakeAnalytics;
